// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/pitch-power-couple.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/pitch-power-couple/pitch-power-couple.js';

mount([g0]);
